export default __webpack_public_path__ + "static/media/icon-site.925dc62b.svg";